(function () {
  function $(root, sel) { return root.querySelector(sel); }
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }
  function nowMs() { return Date.now(); }

  function safeJsonParse(s, fallback) {
    try { return JSON.parse(s); } catch (e) { return fallback; }
  }

  // Ekranda "90" gibi düz saniye gösteriyoruz
  function formatTime(totalSec) {
    totalSec = Math.max(0, Math.floor(totalSec));
    return String(totalSec);
  }

  function init(root) {
    var sectionId = root.getAttribute("data-section-id") || "default";
    var storageKey = "bgames_timer_state_" + sectionId;

    var durationDefault = Number(root.getAttribute("data-duration") || 90);

    var elTime = $(root, "[data-bgames-time]");
    var elStatus = $(root, "[data-bgames-status]");

    var btnStart = $(root, "[data-bgames-start]");
    var btnPause = $(root, "[data-bgames-pause]");
    var btnReset = $(root, "[data-bgames-reset]");

    var tickTimer = null;

    var state = {
      version: 1,
      durationSec: durationDefault,
      remainingSec: durationDefault,
      running: false,
      startedAtMs: null,
      remainingAtStartSec: null
    };

    function load() {
      var saved = safeJsonParse(localStorage.getItem(storageKey), null);
      if (!saved || typeof saved !== "object") return;

      state.durationSec = Number(saved.durationSec ?? state.durationSec);
      state.remainingSec = Number(saved.remainingSec ?? state.remainingSec);
      state.running = Boolean(saved.running);
      state.startedAtMs = saved.startedAtMs ?? null;
      state.remainingAtStartSec = saved.remainingAtStartSec ?? null;

      // Sayfa yenilendiğinde çalışıyorsa, geçen süreyi hesapla
      if (state.running && state.startedAtMs && typeof state.remainingAtStartSec === "number") {
        var elapsedSec = (nowMs() - Number(state.startedAtMs)) / 1000;
        state.remainingSec = clamp(Number(state.remainingAtStartSec) - elapsedSec, 0, 24 * 60 * 60);

        if (state.remainingSec <= 0) {
          state.running = false;
          state.startedAtMs = null;
          state.remainingAtStartSec = null;
        }
      }
    }

    function save() {
      try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (e) {}
    }

    function setStatus(text) { if (elStatus) elStatus.textContent = text; }
    function updateTimeUI() { if (elTime) elTime.textContent = formatTime(state.remainingSec); }

    function stopTick() {
      if (tickTimer) { clearInterval(tickTimer); tickTimer = null; }
    }

    function startTick() {
      stopTick();
      tickTimer = setInterval(function () {
        if (!state.running) return;

        var elapsedSec = (nowMs() - Number(state.startedAtMs || nowMs())) / 1000;
        var newRemain = Number(state.remainingAtStartSec || state.remainingSec) - elapsedSec;
        state.remainingSec = clamp(newRemain, 0, 24 * 60 * 60);

        updateTimeUI();

        if (state.remainingSec <= 0) {
          state.running = false;
          state.startedAtMs = null;
          state.remainingAtStartSec = null;
          setStatus("Süre bitti");
          stopTick();
        }

        save();
      }, 250);
    }

    function start() {
      // süre bittiyse tekrar başlatınca başa al
      if (state.remainingSec <= 0) {
        state.remainingSec = state.durationSec;
      }

      state.running = true;
      state.startedAtMs = nowMs();
      state.remainingAtStartSec = state.remainingSec;

      setStatus("Çalışıyor");
      updateTimeUI();
      startTick();
      save();
    }

    function pause() {
      if (!state.running) return;

      var elapsedSec = (nowMs() - Number(state.startedAtMs || nowMs())) / 1000;
      state.remainingSec = clamp(Number(state.remainingAtStartSec || state.remainingSec) - elapsedSec, 0, 24 * 60 * 60);

      state.running = false;
      state.startedAtMs = null;
      state.remainingAtStartSec = null;

      setStatus("Duraklatıldı");
      updateTimeUI();
      stopTick();
      save();
    }

    function reset() {
      pause();

      // Tema ayarı değiştiyse (duration_seconds), her reset’te yeni değeri baz alalım
      state.durationSec = durationDefault;
      state.remainingSec = state.durationSec;

      setStatus("Hazır");
      updateTimeUI();
      save();
    }

    // Buttons
    if (btnStart) btnStart.addEventListener("click", start);
    if (btnPause) btnPause.addEventListener("click", pause);
    if (btnReset) btnReset.addEventListener("click", reset);

    // Boot
    load();

    // güvenlik sınırları
    state.durationSec = clamp(Number(state.durationSec || durationDefault), 1, 24 * 60 * 60);
    state.remainingSec = clamp(Number(state.remainingSec || state.durationSec), 0, 24 * 60 * 60);

    updateTimeUI();

    if (state.running) {
      setStatus("Çalışıyor");
      startTick();
    } else {
      setStatus("Hazır");
    }

    save();
  }

  function boot() {
    document.querySelectorAll(".bgames").forEach(function (root) {
      try { init(root); } catch (e) { console.error("bgames timer init error", e); }
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
